import { formatDateToDDMMYYYY } from '../../../utils/dateformatter';
import { InfoPrompt, PricingPeriodData } from '../../../constants/masterData';

export const formatPricingPeriodRange = (start, end) => {
  const startLabel = start ? formatDateToDDMMYYYY(start) : '';
  const endLabel = end ? formatDateToDDMMYYYY(end) : '';
  if (!startLabel && !endLabel) return '-';
  if (startLabel && endLabel) return `${startLabel} - ${endLabel}`;
  return startLabel || endLabel;
};

export const getPricingPeriodLabel = pricingPeriod => {
  const value = parseInt(pricingPeriod, 10);
  const option = PricingPeriodData[0]?.options?.find(
    item => item.value === value
  );
  if (option?.label) return option.label;
  if (
    pricingPeriod === null ||
    pricingPeriod === undefined ||
    pricingPeriod === ''
  ) {
    return '-';
  }
  return String(pricingPeriod);
};

export const getInfoPromptLabel = infoPrompt => {
  const value = parseInt(infoPrompt, 10);
  const option = InfoPrompt[0]?.options?.find(item => item.value === value);
  if (option?.label) return option.label;
  if (infoPrompt === null || infoPrompt === undefined || infoPrompt === '') {
    return '-';
  }
  return String(infoPrompt);
};

export const getPricingPeriodDetailLabel = pricingPeriod => {
  const value = parseInt(pricingPeriod, 10);
  if (value === 1) return 'Publish Index Period';
  if (value === 2) return 'Schema B/L Date';
  if (value === 3) return 'Fixed Price';
  return 'Pricing Detail';
};

export const getPricingPeriodDetailValue = data => {
  if (!data) return '-';
  const value = parseInt(data.pricingPeriod, 10);
  if (value === 1) {
    return formatPricingPeriodRange(
      data.startDatePublishIndex,
      data.endDatePublishIndex
    );
  }
  if (value === 2) return data.schemaBL || '-';
  if (value === 3) {
    if (data.priceAmount === null || data.priceAmount === undefined) return '-';
    return data.priceAmount;
  }
  return '-';
};

const pickField = (obj, camelKey, pascalKey) =>
  obj?.[camelKey] ?? obj?.[pascalKey] ?? null;

export const mapParcelPricingDisplay = (item = {}) => {
  const pricingPeriod = pickField(item, 'pricingPeriod', 'PricingPeriod');
  const startDatePublishIndex = pickField(
    item,
    'startDatePublishIndex',
    'StartDatePublishIndex'
  );
  const endDatePublishIndex = pickField(
    item,
    'endDatePublishIndex',
    'EndDatePublishIndex'
  );
  const schemaBL = pickField(item, 'schemaBL', 'SchemaBL');
  const priceAmount = pickField(item, 'priceAmount', 'PriceAmount');
  const infoPrompt = pickField(item, 'infoPrompt', 'InfoPrompt');
  const indexPrice =
    item.indexPrice?.name ??
    item.indexPrice ??
    item.indexPricename ??
    pickField(item, 'indexPrice', 'IndexPrice');
  const otherIndexPrice =
    item.otherIndexPrice?.name ??
    item.otherIndexPrice ??
    item.otherIndexPricename ??
    pickField(item, 'otherIndexPrice', 'OtherIndexPrice');
  const notesForPricing = pickField(item, 'notesForPricing', 'NotesForPricing');

  return {
    pricingPeriod,
    pricingPeriodLabel: getPricingPeriodLabel(pricingPeriod),
    pricingPeriodDetailLabel: getPricingPeriodDetailLabel(pricingPeriod),
    pricingPeriodDetail: getPricingPeriodDetailValue({
      pricingPeriod,
      startDatePublishIndex,
      endDatePublishIndex,
      schemaBL,
      priceAmount,
    }),
    indexPrice:
      typeof indexPrice === 'object' ? (indexPrice?.name ?? null) : indexPrice,
    otherIndexPrice:
      typeof otherIndexPrice === 'object'
        ? (otherIndexPrice?.name ?? null)
        : otherIndexPrice,
    infoPrompt,
    infoPromptLabel: getInfoPromptLabel(infoPrompt),
    notesForPricing,
    startDatePublishIndex,
    endDatePublishIndex,
    schemaBL,
    priceAmount,
  };
};
